import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#C92042" }}>Problem</span>
            </h2>
            <p>
              A strong desire to revolutionize the private equity industry and
              to take on a tech-savvy approach to deliver the best in class
              innovative investment structures that challenge the status quo,
              was the motivation behind the Muirfield website.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/murifield/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={778}
              height={564}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
